<template>
  <div>
    <section v-if="tableType !== 'other'" class="fa-table team-table py2 sans border-top mx-auto">
      <h3 class="sm-hide md-hide lg-hide mb3 red">{{ title }}</h3>
      <div class="row clearfix mxn2">
        <div class="col xs-hide sm-col-4 px2">{{ title }}</div>
        <div class="col col-12 sm-col-8 px2">
          <!-- Exhibition Team Table -->
          <div
            v-if="tableType === 'exhibition'"
            v-for="(item, index) in content"
            class="hover-red row clearfix mb2 mxn2" :key="index">
            <div class="col xs-hide col-6 px2">&nbsp;</div>
            <div class="col col-12 sm-col-6 px2">
              <router-link :to="{name: 'Team Member', params: {slug: item.person.post_name}}">{{ item.person.post_title }}</router-link><span v-if="item.role" class="subdued"> ({{ item.role }})</span>
            </div>
          </div>

          <!-- FA/FO Table -->
          <div
            v-if="tableType === 'fo' || tableType === 'fa'"
            v-for="(item, index) in content"
            class="row clearfix mb2 mxn2" :key="index">
            <div class="col col-6 px2">{{ item.role }}</div>
            <div class="col col-6 px2">
              <div class="hover-red" v-for="person in item.people" :key="person.ID">
                <router-link :to="{name: 'Team Member', params: {slug: person.post_name}}">{{ person.post_title }}</router-link>
              </div>
            </div>
          </div>

          <!-- Collaborators Table (OLD) -->
          <div v-if="tableType === 'collaborators'"
            v-for="(value, key, index) in groupedTeam"
            class="row clearfix mxn2 mb2"
            :key="index">

            <div class="col col-6 px2">
              <span v-if="key !== 'ungrouped'">{{ key }}</span>
              <span v-else>Individual Collaborators</span>
            </div>
            <div class="col col-6 px2">
              <div v-for="item in value" :key="item.person.ID">
                <div v-if="item.person">
                  {{ item.person.post_title }}
                </div>
              </div>
            </div>
          </div>

          <!-- Collaboratoring Orgs Table -->
          <div v-if="tableType === 'collaborating_orgs'"
            v-for="(item, index) in content"
            class="row clearfix mxn2 mb2"
            :key="index">
            <div class="col col-6 px2">
              &nbsp;
            </div>
            <div class="col col-6 px2">
              <a v-if="item.fa_venue_link" :href="item.fa_venue_link" target="_blank" v-text="item.post_title" />
              <span v-else v-text="item.post_title" />
            </div>
          </div>

          <!-- Extended Team Table -->
          <div
            v-if="tableType === 'extended'"
            v-for="(item, index) in content"
            class="row clearfix mb2 mxn2" :key="index">
            <div class="col col-6 px2">
              <span v-if="getItemRole(index, content)" v-html="getItemRole(index, content)" />
              <span v-else>&nbsp;</span>
            </div>
            <div v-if="item.org_position === 'start'" class="col col-6 px2">
              <span v-if="item.organization">
                {{ item.organization.post_title }}<span v-if="item.people">:&nbsp;</span>
              </span>
              <span v-if="item.organization && item.people"></span>
              <ul v-if="item.people" class="comma-list inline list-reset">
                <li v-for="(person, index2) in item.people" :key="`org-person-${index2}`"><router-link class="hover-red" :to="{name: 'Team Member', params: {slug: person.post_name}}" v-html="preventWidows(person.post_title)" /></li>
              </ul>
            </div>
            <div v-else class="col col-6 px2">
              <span v-if="item.people" v-text="getPeople(item.people)"></span>
              <span v-if="item.organization && item.people"></span>
              <span v-if="item.organization">
                ({{ item.organization.post_title }})
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section v-else-if="tableType === 'other'" v-for="(table, index) in content" :key="index" class="fa-table team-table py2 sans border-top mx-auto">
      <h3 class="sm-hide md-hide lg-hide mb3 red">{{ table.table_title }}</h3>
      <div class="row clearfix mxn2">
        <div class="col xs-hide sm-col-4 px2">{{ table.table_title }}</div>
        <div class="col col-12 sm-col-8 px2">
          <!-- Other Team Table -->
          <div
            v-if="tableType === 'other'"
            v-for="(item, index) in table.table_content"
            class="row clearfix mb2 mxn2" :key="index">
            <div class="col col-6 px2">
              <span v-if="item.role" v-text="item.role" />
              <span v-else>&nbsp;</span>
            </div>
            <div class="col col-6 px2">
              <div class="hover-red" v-for="person in item.people" :key="person.ID">
                <router-link :to="{name: 'Team Member', params: {slug: person.post_name}}">{{ person.post_title }}</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {

  name: 'TeamTable',

  data () {
    return {

    }
  },

  props: ['tableType', 'title', 'content'],

  computed: {
    groupedTeam () {
      if (this.tableType === 'collaborators') {
        let groupedTeam = this.content.reduce(function (r, a) {
          if (a.organization) {
            r[a.organization.post_title] = r[a.organization.post_title] || []
            r[a.organization.post_title].push(a)
          } else if (a.text) {
            r[a.text] = r[a.text] || []
            r[a.text].push(a)
          } else {
            r['ungrouped'] = r['ungrouped'] || []
            r['ungrouped'].push(a)
          }
          return r
        }, Object.create(null))

        return groupedTeam
      } else {
        return false
      }
    }
  },

  methods: {
    getPeople (people) {
      let names = people.map(x => x.post_title)
      return names.join(', ')
    },
    getItemRole (index, items) {
      if (index === 0 && items[index].role) {
        return items[index].role
      } else if (index !== 0 && items[index].role !== items[index-1].role) {
        return items[index].role
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="css" scoped>
  .team-table {
    max-width: var(--max-width-med);
    /*font-size: var(--font-size-reader);*/
    line-height: var(--line-height-reader);
  }
</style>
